import {
  createDrawerNavigator,
  DrawerNavigationProp,
} from "@react-navigation/drawer";
import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import {
  createNativeStackNavigator,
  NativeStackNavigationProp,
} from "@react-navigation/native-stack";

import { UserLoggedInNavigatorNavigationProp } from "../../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { EmptyPositionT } from "../EmptyPositions/EmptyPosType";
import { WidgetSizeT } from "../localTypes/WidgetSizeT";

export type WACategoryKey = keyof WACategoryDrawerParamList;

export type WABaseScreenParams = {
  storecastId: string;
  unitSize: number;
  maxSize: WidgetSizeT;
  defaultTeams: string[];
  position: EmptyPositionT;
};

type WACategoryDrawerParamList = {
  WACategoryChecklists: WABaseScreenParams;
  WACategoryWeather: WABaseScreenParams;
  WACategoryIssues: WABaseScreenParams;
  WACategoryTodoCategories: WABaseScreenParams;
  WACategoryDefaultTodoCategory: WABaseScreenParams & { categoryId: string };
  WACategoryNote: WABaseScreenParams;
  WACategoryIntegrations: WABaseScreenParams;
  WACategoryKPI: WABaseScreenParams;
  WACategoryTeamSchedule: WABaseScreenParams;
  WACategoryFile: WABaseScreenParams;
  WACategoryOrgInfo: WABaseScreenParams;
  WACategoryCalendar: WABaseScreenParams;
  WACategorySignals: WABaseScreenParams;
  WACategoryEmployeeRoles: WABaseScreenParams;
};

export type WAStackParamList = {
  WidgetAddMaster: WABaseScreenParams;
} & WACategoryDrawerParamList;

export type WACategoryNavigationProp<
  T extends keyof WACategoryDrawerParamList,
> = CompositeNavigationProp<
  | NativeStackNavigationProp<WAStackParamList, T>
  | DrawerNavigationProp<WACategoryDrawerParamList, T>,
  UserLoggedInNavigatorNavigationProp<"WidgetAdd">
>;

type WACategoryRouteProp<T extends keyof WACategoryDrawerParamList> = RouteProp<
  WACategoryDrawerParamList | WAStackParamList,
  T
>;

export type WACategoryScreenProps<T extends keyof WACategoryDrawerParamList> = {
  navigation: WACategoryNavigationProp<T>;
  route: WACategoryRouteProp<T>;
};

export const WADrawer = createDrawerNavigator<WACategoryDrawerParamList>();
export const WAStack = createNativeStackNavigator<WAStackParamList>();
